import { compile } from 'path-to-regexp';

const toPath = (path: string, data: Object) => {
    return compile(path)(data);
};

export default toPath;
